// The family's profile picture pool (kast-dev-admin's /me/pictures), over the
// shared client in `@jkast90/kast-common/kast-dev-api`, with the app's session.

import {
  deletePicture,
  listPictures,
  uploadPicture,
  type ProfilePictureEntry,
} from "@jkast90/kast-common/kast-dev-api";
import type { ProfilePicture } from "@jkast90/kast-common/ui";
import { session } from "../auth/session";

/** This app's id in the family (the port registry's), shown as the caption of what it uploads. */
export const PICTURES_APP = "kindly2";

const options = () => ({ token: session.bearer() });

/** The picker's shape for a pool entry. */
export const toPicture = (entry: ProfilePictureEntry): ProfilePicture => ({
  id: entry.id,
  url: entry.url,
  createdAt: entry.created_at,
  app: entry.app,
});

export const picturesApi = {
  list: async () => (await listPictures(options())).map(toPicture),
  upload: async (file: File) =>
    toPicture(await uploadPicture(file, { ...options(), app: PICTURES_APP })),
  remove: (id: string) => deletePicture(id, options()),
};
